import React from "react";
import { Route, Routes as SwitchRouter } from "react-router";
import TmsBookings from "../views/bookings/tms-bookings";
import TmsCalender from "../views/calender/tms-calender";
import TmsDevotees from "../views/devotees/tms-devotees";
import TmsOrders from "../views/orders/tms-orders";
import TmsPartners from "../views/partners/tms-partners";
import TmsPos from "../views/pos/tms-pos";
import TmsProfile from "../views/profile/tms-profile";
import TmsReports from "../views/reports/tms-reports";
import TmsServiceManagement from "../views/service-management/tms-service-management";
import TmsSupport from "../views/support/tms-support";
import TmsTempleManagement from "../views/temple-management/tms-temple-management";
import TmsTempleSettings from "../views/temple-settings/tms-temple-settings";
import TmsUserManagement from "../views/user-management/tms-user-management";
import TmsWelcome from "../views/welcome/tms-welcome";
import TmsHomeNew from "../views/home/home-new";

const TmsRoutes = () => {
  return (
    <SwitchRouter>
      <Route path="/welcome" element={<TmsWelcome />} />

      <Route path="/home" element={<TmsHomeNew />} />
      <Route path="/profile" element={<TmsProfile />} />
      <Route path="/partners" element={<TmsPartners />} />

      <Route exact path="/devotees/*" element={<TmsDevotees />} />
      <Route exact path="/pos/*" element={<TmsPos />} />
      <Route
        exact
        path="/service-management/*"
        element={<TmsServiceManagement />}
      />
      <Route exact path="/bookings/*" element={<TmsBookings />} />
      <Route
        exact
        path="/temple-management/*"
        element={<TmsTempleManagement />}
      />
      <Route exact path="/temple-settings/*" element={<TmsTempleSettings />} />
      <Route exact path="/orders/*" element={<TmsOrders />} />
      <Route exact path="/reports/*" element={<TmsReports />} />
      <Route exact path="/user-management/*" element={<TmsUserManagement />} />
      <Route exact path="/support/*" element={<TmsSupport />} />
      <Route path="/calender/*" element={<TmsCalender />} />
      <Route path="/user-management/*" element={<TmsUserManagement />} />
    </SwitchRouter>
  );
};
export default TmsRoutes;
